export default "__VITE_ASSET__By39IE8q__"